// src/components/Common/DeviceGuard.jsx
import { useEffect, useState } from "react";

export default function DeviceGuard({ children }) {
  const getIsAllowedDevice = () => {
    const width = window.innerWidth;
    const userAgent = navigator.userAgent.toLowerCase();

    // Detect iPad (also covers iPadOS that reports as Mac)
    const isIpad =
      /ipad/.test(userAgent) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

    // ✅ Allow if iPad OR width >= 600px
    return isIpad || width >= 600;
  };

  const [isAllowed, setIsAllowed] = useState(getIsAllowedDevice());

  useEffect(() => {
    const handleResize = () => setIsAllowed(getIsAllowedDevice());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!isAllowed) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          fontSize: "1.5rem",
          fontFamily: "sans-serif",
          textAlign: "center",
          padding: "20px",
        }}
      >
        🚫 This app is only available on laptops, desktops, or iPads.  
        Please open it on a larger screen.
      </div>
    );
  }

  return children;
}
